import { getMediaTypeByExtension, getFileExtension } from '../../../utils/extensions';
import { MediaType } from '../../../constants/MediaType';
import { ItemKind } from '../../../constants/ItemKind';
const MEDIA_TYPES_WITH_THUMBNAILS = [MediaType.Video, MediaType.Picture];
const hasThumbnail = extension => ['pdf', 'rtf'].indexOf(extension) >= 0 || MEDIA_TYPES_WITH_THUMBNAILS.indexOf(getMediaTypeByExtension(extension)) >= 0;
const encodePath = uriComponent => encodeURIComponent(uriComponent).replace("'", '%27');
export const toItem = (data, settings) => {
  const fileExtension = getFileExtension(data);
  const mediaType = getMediaTypeByExtension(fileExtension);
  const encodedPath = encodePath(data.path_lower);
  const item = {
    id: data.id,
    name: data.name,
    kind: ItemKind.File,
    source: 'dropbox',
    mediaType,
    fileUrl: data.url,
    thumbnailUrl: `${settings.apiUrl}${settings.apiPath}/thumbnail?path=${encodedPath}`,
    createdAt: data.client_modified,
    tags: [],
    pathLower: data.path_lower
  };
  if (hasThumbnail(fileExtension)) {
    item.previewUrl = `${settings.apiUrl}${settings.apiPath}/thumbnail?path=${encodedPath}&size=w640h480`;
  }
  return item;
};